import $ from 'jquery';

const recaptchaEl = $('.g-recaptcha');

$(function () {
    if (recaptchaEl.length > 0) {
        recaptcha(recaptchaEl);
    }
});

const recaptcha = (el) => {
    grecaptcha.ready(function () {
        el.each(function () {
            grecaptcha.render($(this)[0]);

            const form = el.closest('form');
            form.on('submit', function (e) {
                e.preventDefault();
                grecaptcha.execute();
            });
        })
    });
}

window.recaptchaFormListener = (token) => {
    if (recaptchaEl.length > 0) {
        recaptchaEl.each(function () {
            $(this).find('.g-recaptcha-response').val(token);
        });
    }

    // TODO submit submited form not first
    const form = recaptchaEl[0].closest('form');
    form.submit();
}